import BootIconButton from "components/common/custom/IconButton";
import { motion } from "framer-motion";
import moment from "moment";
import { Card, Col, Row } from "react-bootstrap";
import { BsDownload } from "react-icons/bs";
import { useSelector } from "react-redux";

const PreauthProviderClinicalDocument = () => {
  return (
    <div className="d-flex flex-column gap-3">
      <InvestigationDetails />
      <AttachmentDetails />
    </div>
  );
};

export default PreauthProviderClinicalDocument;

const InvestigationDetails = () => {
  const { viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );

  const clinicalDocs =
    viewPreauthorizationInfo?.provider_request?.clinical_documentation || [];

  // Find the investigation result
  const investigation = clinicalDocs.find(
    (doc) => doc.investigationresult
  )?.investigationresult;
  const additionalInfo = clinicalDocs.find((doc) => doc.addinfo)?.addinfo;

  console.log({ additionalInfo });

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3"
      initial={{ opacity: 0, y: 50 }} // Starts faded out and moved down
      animate={{ opacity: 1, y: 0 }} // Fades in and moves to place
      exit={{ opacity: 0, y: 50 }} // Optional: for exit animation
      transition={{ duration: 0.5 }} // Smooth transition
    >
      {/* Floating Badge Header */}
      <div className="position-absolute top-0 start-40 translate-middle-y px-2">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Investigation Details</span>
        </span>
      </div>
      <Row>
        <Col xs={12}>
          {additionalInfo && (
            <>
              <Row>
                <Col xs={12} md={3}>
                  <span className="fs-10 fw-bold">Additional Info</span>
                </Col>
                <Col xs={12} md={9}>
                  <span className="fs-10 fw-normal text-600">
                    {additionalInfo}
                  </span>
                </Col>
              </Row>
              <hr />
            </>
          )}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Additional Supporting Info</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-600">
                {investigation?.name}
              </span>
            </Col>
          </Row>
          <hr />

          {investigation?.code == "other" && (
            <Row>
              <Col xs={12} md={3}>
                <span className="fs-10 fw-bold">Other Description</span>
              </Col>
              <Col xs={12} md={9}>
                <span className="fs-10 fw-normal text-600">
                  {investigation?.otherdesc}
                </span>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </motion.div>
  );
};

const AttachmentDetails = () => {
  const { viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );

  // Extract clinical docs
  const clinicalDocs =
    viewPreauthorizationInfo?.provider_request?.clinical_documentation || [];

  // Extract all investigation results from clinical docs
  const investigationResults = clinicalDocs
    .map((doc) => doc.investigationresult)
    .filter(Boolean);

  // Combine clinical docs and investigation results
  const docs = [...clinicalDocs, ...investigationResults];

  // Collect all attachments from docs
  let preauthAttachments = [];

  docs.forEach((item) => {
    if (item?.additionalsupinfo) {
      preauthAttachments = preauthAttachments.concat(
        Array.isArray(item.additionalsupinfo)
          ? item.additionalsupinfo
          : [item.additionalsupinfo]
      );
    }
    if (item?.attachment) {
      preauthAttachments = preauthAttachments.concat(
        Array.isArray(item.attachment) ? item.attachment : [item.attachment]
      );
    }
  });

  console.log({ docs, preauthAttachments });

  // Extract file name from attachment (prefer filename if available)
  const getFileName = (attachment) => {
    return (
      attachment.filename ||
      (attachment.url ? attachment.url.split("/").pop() : "Unknown File")
    );
  };

  // Download file directly (no new tab)
  const handleDownload = async (attachment) => {
    try {
      const response = await fetch(attachment.url);
      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = getFileName(attachment);
      link.click();

      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    preauthAttachments.length > 0 && (
      <motion.div
        style={{ border: "2px solid #d9f8eb" }}
        className="rounded p-3 position-relative mt-3"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="position-absolute top-0 start-40 translate-middle-y px-2">
          <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
            <span className="fs-11">Attachment Details</span>
          </span>
        </div>

        <Row>
          {preauthAttachments.map((attachment, index) => {
            const fileName = getFileName(attachment);
            const fileType = fileName.split(".").pop().toUpperCase();

            return (
              <Card key={index} className="p-3 mb-3 rounded border-0">
                <Row className="align-items-center">
                  {/* Number circle */}
                  <Col xs="auto">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle border"
                      style={{
                        width: "40px",
                        height: "40px",
                        color: "#F59E0B",
                        borderColor: "#10B981",
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                      }}
                    >
                      <strong>{index + 1}</strong>
                    </div>
                  </Col>

                  {/* File details */}
                  <Col
                    xs={10}
                    md
                    className="d-flex flex-wrap justify-content-between align-items-center mt-3 mt-md-0"
                  >
                    <div className="d-flex flex-column">
                      <small className="text-muted fw-bold">
                        Document Name
                      </small>
                      <small className="text-600">{fileName}</small>
                    </div>

                    <div className="d-flex flex-column">
                      <small className="text-muted fw-bold">
                        Document Type
                      </small>
                      <small className="text-600">{fileType}</small>
                    </div>
                    {/* Download button */}
                    <Col xs="auto" className="text-end">
                      <BootIconButton
                        variant="success"
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: "30px", height: "30px" }}
                        onClick={() => handleDownload(attachment)}
                      >
                        <BsDownload size={18} color="#fff" />
                      </BootIconButton>
                    </Col>
                  </Col>
                </Row>
              </Card>
            );
          })}
        </Row>
      </motion.div>
    )
  );
};
